import React from 'react';
import About from './About';
import Home from './Home';

const HomePage = () => {
    return (
        <div>
            <Home></Home> 
            <About></About>
           
        </div>
    );
};

export default HomePage;